import(/* webpackMode: "eager", webpackExports: ["default"] */ "/workspace/src/app/components/account/account.jsx");
